import {ValidationObserver, ValidationProvider} from "vee-validate";
import firebase from "firebase/app";

export default {
  name: "ContentEditDlg",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      name: '',
      loading: false,
    }
  },
  computed: {
    contentId() {
      return this.$route.params.id;
    }
  },
  methods: {
    open(name: string) {
      this.dialog = true;
      this.name = name;
    },
    close() {
      this.dialog = false;
    },
    editContentName() {
      this.loading = true;

      firebase
        .firestore()
        .collection("creatorContent")
        .doc(this.contentId)
        .update({
          name: this.name
        }).then(async () => {
          await this.$store.dispatch("getCurrentCreatorContent", this.$route.params.id);
          this.loading = false;
          this.close();
          this.$toast.open({
            message: this.$t("ContentEditDlg.ContentHasBeenEdited"),
            type: 'success',
          })
      }).catch((error) => {
        this.loading = false;
        this.$toast.open({
          message: this.$t("ContentEditDlg.ErrorEditingContent"),
          type: 'error',
        })
      })
    }
  }
}